<!-- <nav
  class="navbar navbar-light bg-light footer-nav fixed-bottom justify-content-end"
  role="navigation"
>
  <ul class="nav me-5">
    <li class="nav-item pull-right">
      <a class="nav-link" href="http://azdeq.gov/mydeq_home" target="_blank"
        >HELP/CONTACT</a
      >
    </li>
    <li class="nav-item"><a class="nav-link ps-0">|</a></li>
  </ul>
</nav> -->


<nav class="navbar page-footer fixed-bottom navbar-expand-lg">
  <div class="container-fluid">
    <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
      <a class="nav-link h6" href="https://azdeq.gov/mydeq/help" target="_blank">
        HELP/CONTACT <span class="divider">|</span>
      </a>
    </div>
  </div>
</nav>
